module.exports = __webpack_public_path__ + "img/9788952753649.49b77e4c.jpg";